<div class="container user-info-box">
  <!-- <div class="user-info-box-item">{{ 'header.welcome.text' | translate }}</div> -->
  <div class="user-info-box-item login-status">
    <custom-login-status view="full" class="login-status" />
  </div>

  <div *ishFeature="'orderTemplates'" class="user-info-box-item">
    <a routerLink="/account/order-templates"> Order Templates <i class="icon-heart"></i></a>
  </div>

  <div *ishFeature="'compare'" class="user-info-box-item">
    <ish-lazy-product-compare-status view="full" />
  </div>

  <div *ishFeature="'wishlists'" class="user-info-box-item">
    <ish-lazy-wishlists-link view="auto" />
  </div>

  <!-- Hide language switch in the dotcms edit view. We can use dotcms language switch in the edit view -->
  <!-- @if (!isInsideIframe()) { -->
  <div class="user-info-box-item">
    <custom-language-switch view="accordion" placement="up" />
  </div>
  <!-- } -->
</div>
